export const ROLES = {
	ADMIN: "admin",
	GESTOR: "gestor",
};

export const LOGS = {
	FIELDS: {
		LOGIN: "login",
		ARTWORKS: "artworks",
		ARTWORK_TYPES: "artwork-types",
		ADMINS: "admins",
		ARTISTS: "artists",
		ARTIST_TYPES: "artist-types",
		COUNTRIES: "countries",
		SUPPLIERS: "suppliers",
		ARTISTIC_MOVEMENTS: "artistic-movements",
	},
	ACTIONS: {
		LOGIN: "login",
		CREATE: "create",
		UPDATE: "update",
		DELETE: "delete",
		DISABLE: "enable",
		RESTORE: "restore",
		ENABLE: "disable",
	},
};
